import React, { useEffect, useState } from "react";
import { Table, Spinner, Alert, Badge } from "react-bootstrap";
import { getAuditSessions } from "../../services/AuditServices";
import { Link } from "react-router-dom";
import Pagination from "../Constant/Pagination";
import { Icon } from "../../components";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Typography from "@mui/material/Typography";
import { IoIosWarning } from "react-icons/io";
import { endAuditSessionApi } from "../../services/AuditService";
import { toast } from "react-toastify";
import Button from "@mui/material/Button";
import { FiEdit, FiChevronDown, FiChevronUp } from "react-icons/fi";
import { useSelector } from "react-redux";
import { OnlyAdmin } from "../../router/permission";
import { ImSpinner3 } from "react-icons/im";
import { RiVerifiedBadgeFill } from "react-icons/ri";

const Audit = () => {
  const role = useSelector((state) => state.auth.user.role || "user");
  const [sessions, setSessions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [page, setPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [completeModal, setCompleteModal] = useState(false);
  const [completeLoading, setCompleteloading] = useState(false);
  const [sessionInfo, setSessionInfo] = useState({});
  const [expandedRows, setExpandedRows] = useState({});
  const recordsPerPage =10;

  const handleToggleCompleteModal = () => {
    setCompleteModal(!completeModal);
  };

  const handleCompleteSession = () => {
    setCompleteloading(true);
    endAuditSessionApi(sessionInfo?.id || "")
      .then(() => {
        handleToggleCompleteModal();
        toast.success("Session Completed Successfully");
        fetchSessions();
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setCompleteloading(false);
      });
  };

  const fetchSessions = async () => {
    try {
      setLoading(true);
      const response = await getAuditSessions({ page,page_size: recordsPerPage });
      setSessions(response.data.results || []);
      setTotalCount(response.data.count || 0);
    } catch (err) {
      setError("Failed to fetch audit sessions.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSessions();
  }, [page]);

  const handlePagination = (selectedItem) => {
    const selectedPage = selectedItem.selected + 1;
    setPage(selectedPage);
  };

  const renderListWithToggle = (items, sessionId, type, labelKey = null) => {
    if (!items || items.length === 0) return "—";

    const isExpanded = expandedRows[`${sessionId}_${type}`] || false;
    const visibleItems = isExpanded ? items : items.slice(0, 2);

    return (
      <div>
        {visibleItems.map((item, index) => (
          <Badge key={index} bg="light" text="dark" className="me-1 mb-1">
            {labelKey ? item[labelKey] : item}
          </Badge>
        ))}
        {items.length > 2 && (
          <Button
            variant="text"
            size="small"
            onClick={() =>
              setExpandedRows((prev) => ({
                ...prev,
                [`${sessionId}_${type}`]: !isExpanded,
              }))
            }
            startIcon={
              isExpanded ? (
                <FiChevronUp size={14} />
              ) : (
                <FiChevronDown size={14} />
              )
            }
            sx={{
              fontSize: "0.70rem",
              minHeight: "auto",
              padding: "2px 6px",
              textTransform: "none",
            }}
          >
            {isExpanded ? "Show less" : `+${items.length - 2} more`}
          </Button>
        )}
      </div>
    );
  };

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h2 className="text-primary mb-0">Audit Sessions</h2>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb breadcrumb-arrow mb-0">
              <li className="breadcrumb-item">
                <Link to="/">Dashboard</Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Audit
              </li>
            </ol>
          </nav>
        </div>
        <div>
          {OnlyAdmin.includes(role) && (
            <Link to="/session-add" className="btn btn-primary">
              <Icon name="plus" /> <span>Add Session</span>
            </Link>
          )}
        </div>
      </div>

      <div className="card">
        <div className="card-body p-0">
          {loading ? (
            <div className="text-center my-5">
              <Spinner animation="border" />
            </div>
          ) : error ? (
            <Alert variant="danger" className="m-3">
              {error}
            </Alert>
          ) : sessions.length === 0 ? (
            <Alert variant="info" className="m-3">
              No audit sessions found.
            </Alert>
          ) : (
            <>

            <div className="table-responsive">
              <Table className="mb-0 fs-6">
                <thead className="custom-thead table-light">
                  <tr>
                    <th style={{minWidth:'150px'}}>Session</th>
                    <th>Auditors</th>
                    <th>Location</th>
                    <th>Department</th>
                    <th>Area</th>
                    <th>Session Dates</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {sessions.map((session) => (

                    <tr key={session.id}>
                      <td>
                        <div className="d-flex flex-column">
                          <Link
                            to={`/audit-session/${session.id}`}
                            className="text-primary fw-medium"
                          >
                            {session.name}
                          </Link>
                          <span className="text-dark fw-medium" style={{fontSize:'0.8rem'}}>{session?.location||'-'}</span>
                        </div>
                      </td>
                      <td>

                          {renderListWithToggle(
                            session.auditors,
                            session.id,
                            "auditors",
                            "fullname"
                          )}
                        </td>

                        <td>{session.location || "—"}</td>
                        <td>
                          {renderListWithToggle(
                            session.department,
                            session.id,
                            "department"
                          )}
                        </td>
                        <td>
                          {renderListWithToggle(
                            session.area,
                            session.id,
                            "area"
                          )}
                        </td>
                        <td>
                          {session.start_date
                            ? `${new Date(
                                session.start_date
                              ).toLocaleDateString("en-GB", {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                              })} - ${
                                session.end_date
                                  ? new Date(
                                      session.end_date
                                    ).toLocaleDateString("en-GB", {
                                      day: "2-digit",
                                      month: "short",
                                      year: "numeric",
                                    })
                                  : "Ongoing"
                              }`
                            : "—"}
                        </td>
                        <td>
                          {session.end_date ? (
                            <span className="badge bg-success d-flex align-items-center gap-1">
                              <RiVerifiedBadgeFill  size={16} />
                              Completed
                            </span>
                          ) : (
                            <button
                              className="badge bg-warning border-0 d-flex align-items-center gap-1 text-dark"
                              style={{
                                cursor: "pointer",
                                transition: "all 0.2s ease",
                              }}
                              onClick={() => {
                                setSessionInfo(session);
                                handleToggleCompleteModal();
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor =
                                  "#e0a800"; // Darker Orange
                                e.currentTarget.style.transform = "scale(1.05)";
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor =
                                  "#ffc107"; // Original bg-warning
                                e.currentTarget.style.transform = "scale(1)";
                              }}
                            >
                              <ImSpinner3 size={14} className="spin" />
                              In Progress
                            </button>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>

              <div className="p-3">
                <Pagination
                  currentPage={page}
                  recordsPage={recordsPerPage}
                  dataLength={totalCount}
                  handlePagination={handlePagination}
                />
              </div>
            </>
          )}
        </div>
      </div>
      <Dialog
        open={completeModal}
        onClose={handleToggleCompleteModal}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            color: "error.main",
            fontWeight: 600,
          }}
        >
          <IoIosWarning className="text-danger" />
          Complete Session
        </DialogTitle>
        <DialogContent>
          <Typography variant="body1" sx={{ mb: 2 }}>
            Are you sure you want to <strong>complete this session</strong>?{" "}
            <br />
            Once completed, you{" "}
            <span style={{ color: "#d32f2f", fontWeight: 500 }}>
              cannot undo this action.
            </span>
          </Typography>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button
            onClick={handleToggleCompleteModal}
            variant="outlined"
            color="inherit"
            disabled={completeLoading}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="error"
            disabled={completeLoading}
            sx={{ minWidth: 110 }}
            onClick={handleCompleteSession}
          >
            {completeLoading && (
              <Spinner animation="border" size="sm" className="me-1" />
            )}
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Audit;
